import TrainerInfoCheckItem from './TrainerInfoCheckItem';

export default function TrainerInfoPrivateTraining({ value }) {
  return (
    <TrainerInfoCheckItem label="Cursos privados (in-company)" value={value} />
  );
}
